// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyBLXEtoyv8VC91iTalnxA7fLBSimyTENbg",
    authDomain: "dashboard-55d2a.firebaseapp.com",
    projectId: "dashboard-55d2a",
    storageBucket: "dashboard-55d2a.appspot.com",
    messagingSenderId: "931610826771",
    appId: "1:931610826771:web:2473b9cba1c12aab2547e6"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
